module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABJUlEQVQ4T2NkoCL4niFXz0gt80CGMTAwNFDFQJhhIMdRbCCyYRQbiG4YRQZiM4xsA3EZRpaB+Awj2UBChpFkIF7D2LkZGH5+BSdpopIN3jATkWVgK9vA8LPegYHh+2fCBuJ1GTMrA1vxGoa/pzcw/N0/n7ALUQxj5WBgtghm+Ht4KTy3sgRXMzCKKjD8npEKF8PpZQyXsbCBXfPv+iGGP5t6GJh0HBlYI1oZfrZ5MTB8+4DfQJze5BZkYCtdx/Dv7GYGZutIhl+zMxn+3z2DUr5guJBQ0mAUlGJgK1vP8PfgIoY/O6ZiFFYoBhIyDK6bnYuB4ec3bCXfJ7iBRBuGpwBlZPy/DmwgNQz7z8DwnunvXwtGKhj26T/D/73M//5Wsc96dgMAFTNvjHXqcj0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fuwuxiang/service details_btn_gg_sel.png
// module id = clg4
// module chunks = 1